export default httpClient => ({

    get: async ({ token }) => {
        let headers = {
         "Authorization": "Bearer " + token
      }
      const response = await httpClient.get('/configuracao', {
         headers
      })

        return {
            data: response.data,
        }
    },
    update: async ({ client_id, url, client_secret, code, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.put('/configuracao/1', {
        client_id,
        url,
            client_secret,
        code
        }, { headers });
        return {
        data: response.data
        }
    },
    
    salvarCode: async ({ code, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.post('/configuracao/salvar-code', {
        code
        }, { headers });
        return {
        data: response.data
        }
    },

        fazerAutenticacao: async ({ code, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.post('/configuracao/gerar-token', {
        code
        }, { headers });
        return {
        data: response.data
        }
    },
});